export class Auth {

    constructor(){
        this.formLogin();
        this.formRegisterUser();
        this.formRecoveryPassword();
        this.formRecoveryEmail();
    }

    formLogin(){
        const form = document.querySelector('form#login_form');
        const intended_url = jQuery('#login_intended_url').val();
        if (form) {
            form.addEventListener('submit', e => {
                e.preventDefault();
                jQuery.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: appVars.ajaxUrl,
                    data: {
                        'action': 'authLogin',
                        'username': form.querySelector('#email_login').value, 
                        'password': form.querySelector('#password_login').value, 
                        'security': form.querySelector('#security').value,
                        'intended_url': intended_url,
                    },
                    error: function(response){
                        console.log(response);
                    },
                    beforeSend: function(){
                        document.querySelector('form#login_form').classList.add('__loading');
                    },
                    success: function(response){
                        // console.log(response);
                        if (response.loggedin == true){
                            // document.location.href = appVars.authRedirect;
                            document.location.href = response.redirect;
                        } else {
                            document.querySelector('#result_login').innerHTML = `<p>${response.message}</p>`;
                            document.querySelector('form#login_form').classList.remove('__loading');
                        }
                    }
                });
            });
        }
    }

    formRegisterUser(){
        const form = document.querySelector('form#register_form');
        // const thanks = document.querySelector('#welcome_user');
        if (form) {
            const responseError = document.querySelector('#textErrorRegister');
            form.addEventListener('submit', e => {
                e.preventDefault();
                const params = {
                    action : 'authRegisterUser',
                    nonce : form.querySelector('#rs_user_register_nonce').value,
                    register_name : form.querySelector('#register_name').value,
                    register_last_name : form.querySelector('#register_last_name').value,
                    register_email : form.querySelector('#register_email').value,
                    register_dni : form.querySelector('#register_dni').value,
                    // register_phone : form.querySelector('#register_phone').value,
                    register_password : form.querySelector('#register_password').value,
                    register_terms : form.querySelector('#register_terms').checked,
                };
                // console.log(params);

                jQuery.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: appVars.ajaxUrl,
                    data: params,
                    error: function(response){
                        console.log(response);
                    },
                    beforeSend: function(){
                        document.querySelector('form#register_form').classList.add('__loading');
                    },
                    success: function(response){
                        // console.log(response);
                        if (!response.registered){
                            // responseError.style.display = 'block';
                            responseError.textContent = response.message;
                        } else {
                            // form.style.display = 'none';
                            // document.querySelector('.forms_content.user_login_content').style.display = 'none';
                            // document.querySelector('.other_login').style.display = 'none';
                            // thanks.style.display = 'block';
                            // jQuery('html, body').stop().animate({
                            //     scrollTop: 0
                            // }, 1000);
                            // console.log(response);
                            // const isFromChk = form.querySelector('#registerFromCheck')?.value;
                            // if (isFromChk == 1) {
                                // setTimeout(() => {
                                    document.location.href = appVars.authRedirect;
                                // }, 2000);
                            // }
                        }
                        document.querySelector('form#register_form').classList.remove('__loading');
                    }
                });
            });

        }
    }

    formRecoveryPassword(){
        const form = document.querySelector('#forgot_password_form');
        if (form) {
            // validacion boton submit
            form.addEventListener('submit', e => {
                e.preventDefault();
                jQuery.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: appVars.ajaxUrl,
                    data: {
                        action : 'recoveryPassword',
                        nonce : form.querySelector('#rs_user_lost_password_nonce').value,
                        user_login : form.querySelector('#email_password_recovery').value,
                    },
                    error: function(response){
                        console.log(response);
                    },
                    beforeSend: function(){
                        document.querySelector('#resultRecovery .error').textContent = '';
                        document.querySelector('#resultRecovery .success').textContent = '';
                        document.querySelector('form#forgot_password_form').classList.add('__loading');
                    },
                    success: function(response){
                        document.querySelector('form#forgot_password_form').classList.remove('__loading');
                        if (!response.email_sent) {
                            document.querySelector('#resultRecovery .error').textContent = response.message;
                        } else {
                            document.querySelector('#resultRecovery .success').textContent = response.message;
                        }
                    }
                });
            });
        }
    }

    formRecoveryEmail(){
        jQuery('#forgot_email_form').on('submit', function(e){
            e.preventDefault();
            const dni = jQuery('#recover_mail_dni').val()
            jQuery.ajax({
                type: 'GET',
                dataType: 'json',
                url: appVars.ajaxUrl,
                data: {
                    action : 'authRecoverEmail',
                    nonce : jQuery('#rs_user_recover_mail_nonce').val(),
                    user_dni : dni,
                },
                error: function(response){
                    console.log(response);
                    document.querySelector('#forgot_email_form').classList.remove('__loading');
                },
                beforeSend: function(){
                    // document.querySelector('#resultRecovery .error').textContent = '';
                    // document.querySelector('#resultRecovery .success').textContent = '';
                    document.querySelector('#forgot_email_form').classList.add('__loading');
                    jQuery('#emailrecover_text').text('');
                    jQuery('#resultRecoveryForm .error_form').text('')
                },
                success: function(response){
                    // console.log(response)
                    document.querySelector('#forgot_email_form').classList.remove('__loading');
                    if (response.found) {
                        jQuery('#recover_email_form_content').hide();
                        jQuery('#show_email_success').show();
                        jQuery('#emailrecover_text').text(response.email_masked);
                    } else {
                        jQuery('#resultRecoveryForm .error_form').text(response.error_message)
                    }
                }
            });
        })
    }
}